import React from 'react';
import './AutoStorePage.css';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';

const PRODUCTS = [
  {
    id: 1,
    name: 'Nano Ceramic Window Film',
    price: 120,
    image: 'https://images.pexels.com/photos/3802510/pexels-photo-3802510.jpeg',
    desc: 'Premium heat rejection, UV protection, and crystal-clear visibility.'
  },
  {
    id: 2,
    name: 'Reflective Solar Tint',
    price: 95,
    image: 'https://images.pexels.com/photos/358070/pexels-photo-358070.jpeg',
    desc: 'Modern privacy and glare reduction for your vehicle.'
  },
  {
    id: 3,
    name: 'Windshield Protection Film',
    price: 150,
    image: 'https://images.pexels.com/photos/1707828/pexels-photo-1707828.jpeg',
    desc: 'Protects against chips, cracks, and UV rays.'
  },
  {
    id: 4,
    name: 'Paint Protection Film',
    price: 200,
    image: 'https://images.pexels.com/photos/358070/pexels-photo-358070.jpeg',
    desc: 'Invisible shield for your car\'s paintwork.'
  },
  {
    id: 5,
    name: 'Headlight Tint Film',
    price: 40,
    image: 'https://images.pexels.com/photos/1149137/pexels-photo-1149137.jpeg',
    desc: 'Stylish and protective headlight tint.'
  },
];

const AutoStorePage = () => {
  const { cart, addToCart } = useCart();
  const navigate = useNavigate();

  return (
    <main className="auto-store-main">
      <section className="auto-store-hero">
        <h1>Auto Store</h1>
        <p>Shop premium automotive films and accessories. Protect, style, and enhance your ride with Derma Protec's best-in-class products.</p>
      </section>
      <section className="auto-products-section">
        <div className="auto-products-grid">
          {PRODUCTS.map((product) => (
            <div className="auto-product-card" key={product.id}>
              <img src={product.image} alt={product.name} className="auto-product-img" />
              <h2 className="auto-product-name">{product.name}</h2>
              <p className="auto-product-desc">{product.desc}</p>
              <div className="auto-product-bottom">
                <span className="auto-product-price">${product.price}</span>
                <button className="auto-add-btn" onClick={() => addToCart(product)}>Add to Cart</button>
              </div>
            </div>
          ))}
        </div>
      </section>
      <button className="auto-cart-toggle" onClick={() => navigate('/cart')}>
        🛒 Cart ({cart.reduce((sum, item) => sum + item.qty, 0)})
      </button>
    </main>
  );
};

export default AutoStorePage; 